import { ReactNode } from 'react'
import { Grid } from '@mui/material'

import { AccountRelationsCountKeys } from 'src/types'
import { AddEntityBtn } from '../entities-add-button'

import useStyle from './styles'

interface IGridListProps {
  routeToAdd?: string
  addButtonLT?: string
  children: ReactNode
  entityCountKey?: AccountRelationsCountKeys
  showUpgrade?: boolean
}

const GridList = ({
  routeToAdd,
  children,
  entityCountKey,
  showUpgrade = false,
  addButtonLT,
}: IGridListProps) => {
  const classes = useStyle()

  return (
    <Grid container className={classes.gridListWrapper}>
      {children}
      <AddEntityBtn
        upgrateTextLT={addButtonLT ?? 'product-create-upgrade-text'}
        entityCountKey={entityCountKey ?? 'productsCount'}
        view="grid"
        showUpgrade={showUpgrade}
        routeToAdd={routeToAdd}
      />
    </Grid>
  )
}

export { GridList }
